import * as React from 'react'
import { connect } from 'react-redux'
import { TidewaysContext } from '../../app/context'
import { MarkerEvent } from '../../domain/Event'
import { ApplicationState } from '../../redux/ApplicationState'
import PerformanceComparisonWithTransactions from '../events/performanceComparisonWithTransactions'

interface Props {
    router: any
    tidewaysContext: TidewaysContext
}

// Deep-link only screen to compare two arbitrary timeframes (ts_before/m_before vs. ts_after/m_after
// query parameters), reusing the release/marker comparison UI. There is no real Event behind this
// comparison, so a stub is passed in its place.
const stubEvent: MarkerEvent = {
    id: 0,
    type: 'marker',
    label: 'Comparison',
    name: 'Custom comparison',
    description: '',
    shortName: 'Comparison',
    icon: '',
    eventDate: '',
    compareBeforeTime: '',
    comparisonAvailableDate: '',
    compareAfterTime: '',
}

class CompareRangeComponent extends React.Component<Props> {
    public render() {
        return (
            <PerformanceComparisonWithTransactions
                title="Comparison"
                event={stubEvent}
                router={this.props.router}
                showDetails={true}
                tidewaysContext={this.props.tidewaysContext}
                titleAsRangeComparison={true}
            />
        )
    }
}

export default connect((globalState: ApplicationState) => ({
    router: globalState.tidewaysContext.router,
    tidewaysContext: globalState.tidewaysContext,
}))(CompareRangeComponent)
